import { useState, type ComponentPropsWithRef, type ReactNode } from "react";

type VideoWithFallbackProps = ComponentPropsWithRef<"video"> & {
    src: string;
    fallback: ReactNode;
    overlay?: ReactNode;
};

export function VideoWithFallback({
    src,
    fallback,
    overlay,
    ref,
    onError,
    ...props
}: VideoWithFallbackProps) {
    const [failedSrc, setFailedSrc] = useState<string | null>(null);

    if (!src || failedSrc === src) return fallback;

    return (
        <>
            {/* oxlint-disable-next-line jsx-a11y/media-has-caption -- Captions are provided by callers when available. */}
            <video
                {...props}
                key={src}
                src={src}
                ref={(node) => {
                    const cleanup =
                        typeof ref === "function" ? ref(node) : undefined;
                    if (ref && typeof ref !== "function") ref.current = node;
                    if (node?.error) setFailedSrc(src);
                    return cleanup;
                }}
                onError={(event) => {
                    setFailedSrc(src);
                    onError?.(event);
                }}
            />
            {overlay}
        </>
    );
}
